/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import caseInsuranceTranslations from "./caseInsuranceTranslations";
import personTranslations from "./personTranslations";
import customerTranslations from "./customerTranslations";

const abstractCaseTranslations = {
  name: {
    label: "Art des Vertrags",
    options: {
      eventContract: {
        label: "Veranstaltung",
      },
      membershipContract: {
        label: "Mitgliedschaft",
      },
      otherContract: {
        label: "Sonstiger Vertrag",
      },
      providerContract: {
        label: "Versorgervertrag",
      },
      dataLeakContract: {
        label: "Datenweitergabe",
      },
      purchaseContract: {
        label: "Kaufvertrag",
      },
      serviceContract: {
        label: "Dienstleistungsvertrag",
      },
      subscriptionContract: {
        label: "Abonnement",
      },
      travelContract: {
        label: "Reisevertrag",
      },
      vehicleContract: {
        label: "Fahrzeugkaufvertrag",
      },
    },
  },
  caseCategory: {
    label: "Ihr Anliegen",
    options: {
      enforceClaim: {
        label: "Forderung durchsetzen",
      },
      defendClaim: {
        label: "Forderung abwehren",
      },
      advisory: {
        label: "Nur kurze Beratung",
      },
    },
  },
  legalExpenseInsurance: {
    label: "Rechtsschutzversicherung vorhanden",
    options: {
      yes: {
        label: "Ja",
      },
      no: {
        label: "Nein",
      },
      true: {
        label: "Ja",
      },
      false: {
        label: "Nein",
      },
    },
  },
  customer: {
    ...customerTranslations,
  },
  client: {
    ...personTranslations,
  },
  caseInsurance: {
    ...caseInsuranceTranslations,
  },
};

export default abstractCaseTranslations;
